import { useReadOnly } from 'utils/lifecycle'
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { get } from 'lodash';
import api from 'utils/api';
import { Box, Button, Card, CardActions, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { Payment as PaymentIcon } from '@mui/icons-material';
import AddCard from './components/AddCard';
import AddBalance from './components/AddBalance';
import AddPromo from './components/AddPromo';
import SetReload from './components/SetReload';
import BusinessPage from '../../components/BusinessPage';
import { ConfirmationDialog } from 'components';
import * as businessActions from 'modules/Business/actions';
import * as userActions from 'modules/User/actions';
import { fetchBusiness } from 'modules/Business/actions';
import PaymentForm from 'modules/Business/modules/PaymentForm';
import AutoReloadButton from 'modules/Business/components/AutoReloadButton';
import AutoReloadPreference, {
  useAutoReloadPreference,
} from 'modules/Business/components/AutoReloadPreference';
import { Elements } from '@stripe/react-stripe-js';  // Import Elements
import { loadStripe } from '@stripe/stripe-js';  // Import loadStripe
import { getBalanceColor } from 'utils/balanceColor';  // Adjust the import path as necessary
import { stripeApiKey } from 'utils/config';

// Create a Stripe promise
const stripePromise = loadStripe(stripeApiKey);

const NewCardPaymentForm = ({ business, onClose }) => {
  const autoReloadPreference = useAutoReloadPreference(business);

  return (
    <>
      <Grid item lg={6} md={6} sm={12} xs={12} mt={2}>
        <AutoReloadPreference
          preference={autoReloadPreference}
          sx={{ width: '100%', height: '100%', boxSizing: 'border-box' }}
        />
      </Grid>
      <Grid item xs={12}>
        <Elements stripe={stripePromise}>
          <PaymentForm
            businessId={business.businessId}
            onClose={onClose}
            autoReloadPreference={autoReloadPreference}
            showAutoReloadPreference={false}
          />
        </Elements>
      </Grid>
    </>
  );
};

const Credits = () => {
  const readOnly = useReadOnly()
  const dispatch = useDispatch();
  const [showCardSelection, setShowCardSelection] = useState(false);
  const [showBalancePopup, setShowBalancePopup] = useState(false);
  const [showReloadPopup, setShowReloadPopup] = useState(false);
  const [showPromoPopup, setShowPromoPopup] = useState(false);
  const [showPaymentForm, setShowPaymentForm] = useState(false);

const paymentMethodIds = useSelector(state => get(state, 'business.paymentMethodIds', []));
const userCards = useSelector(state => get(state, 'user.details.cards', []));

  //const userCards = useSelector(state => get(state, 'user.details.cards', []));
  //const userCards = useSelector(state => get(state, 'business.paymentMethodIds', []));
  const userHasCard = Array.isArray(userCards) && userCards.length > 0;
  const business = useSelector(state => state.business);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const businessId = useSelector(state => get(state, 'business.businessId'));

  //const businessHasCard = business.card || (paymentMethodIds && paymentMethodIds.length > 0);
  const businessHasCard = business.card && business.card.brand && business.card.last4 && business.card.expMonth && business.card.expYear && (paymentMethodIds && paymentMethodIds.length > 0);


  // Map over paymentMethodIds and to find  userCards
// const attachedCards = useMemo(() => {
//   return paymentMethodIds.map(pmId =>
//     userCards.find(card => card.id === pmId)
//   ).filter(Boolean); // remove undefined if not found
// }, [paymentMethodIds, userCards]);

//console.log('------------------attachedCards:', attachedCards);
  useEffect(() => {
    dispatch(fetchBusiness(business.businessId, true));
  }, [dispatch, business.businessId]);

const handleDeleteCard = useCallback((cardId) => {
  //const cardId = get(business, 'card.id');
  
 // if (!cardId) return;

  api
    .delete(`/stripe/customer/card/${cardId}`)
    .then(() => {
      setConfirmDelete(false);
      enqueueSnackbar('Card deleted', { variant: 'success' });
      dispatch(businessActions.fetchBusiness(businessId, true));
      dispatch(userActions.fetchUser());
    })
    .catch(() => {
      enqueueSnackbar('Cannot delete card', { variant: 'error' });
    });
}, [business, businessId, dispatch, enqueueSnackbar]);

  return (
    <BusinessPage title="Payments">
      <fieldset disabled={readOnly} style={{ border: 0, padding: 0, margin: 0 }}>
      {console.log('------------------userCards:', userCards) }
      <Box p={2}>
        <Grid container spacing={3}>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Card>
              <CardHeader
                title="Account balance"
                subheader={`${business.accountBalance}`}
                subheaderTypographyProps={{ variant: 'h6', color: getBalanceColor(business.accountBalance, business) }}
                titleTypographyProps={{ variant: 'body2', color: 'textSecondary' }}
              />
            </Card>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Card>
              <CardHeader
                title="Credit balance"
                subheader={`${business.creditBalance}`}
                subheaderTypographyProps={{ variant: 'h6', color: 'textPrimary' }}
                titleTypographyProps={{ variant: 'body2', color: 'textSecondary' }}
              />
            </Card>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Card>
              <CardHeader
                title="Promotional balance"
                subheader={`${business.couponBalance}`}
                subheaderTypographyProps={{ variant: 'h6', color: 'textPrimary' }}
                titleTypographyProps={{ variant: 'body2', color: 'textSecondary' }}
              />
            </Card>
          </Grid>
          <Grid item lg={3} md={3} sm={6} xs={12}>
            <Card>
              <CardHeader
                title="Reload amount"
                subheader={`${business.reloadAmount}`}
                subheaderTypographyProps={{ variant: 'h6', color: 'textPrimary' }}
                titleTypographyProps={{ variant: 'body2', color: 'textSecondary' }}
              />
            </Card>
          </Grid>
        </Grid>
        <Grid container spacing={3} alignItems="stretch">
          {!businessHasCard ? (
            <Grid item lg={6} md={showPaymentForm ? 6 : 8} sm={12} xs={12} mt={2}>
              <Card>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                  <Typography gutterBottom variant="h6" component="h2">
                    Current payment method
                  </Typography>
                  {/* <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => setShowPaymentForm(true)}
                    sx={{ ml: 2 }}
                  >
                    Add new card
                  </Button> */}
                </Box>
                  <Typography variant="body2" color="textSecondary" component="p">
                    {userHasCard
                      ? 'Select credit card from your account'
                      : 'You need to add credit card to your business profile '}
                  </Typography>
                </CardContent>
                <CardActions>
                  {userHasCard ? (
                    <>
                    <Button disabled={readOnly} color="primary" variant="contained" onClick={() => setShowPaymentForm(true)}>
                      Add new card
                    </Button>
                    <Button disabled={readOnly} color="primary" variant="contained" onClick={() => setShowCardSelection(true)}>
                      Select card
                    </Button>
                    </>
                  ) : (
                    <Button disabled={readOnly} color="primary" onClick={() => setShowPaymentForm(true)}>
                      Add a card
                    </Button>
                  )}
                </CardActions>
              </Card>
            </Grid>
          ) : (
            <Grid item lg={6} md={showPaymentForm ? 6 : 10} sm={12} xs={12} mt={2}>
              <Card>
                <CardContent>
                  <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
                  <Typography gutterBottom variant="h6" component="h2">
                    Current payment method
                  </Typography>
                  {/* <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => setShowPaymentForm(true)}
                    sx={{ ml: 2 }}
                  >
                    Add new card
                  </Button> */}
                </Box>
                  <Box pt={2} display="flex" alignItems="center">
                    <PaymentIcon fontSize="small" style={{ marginRight: 4 }} />
                    <Typography variant="body1" color="textSecondary" component="p">
                                            {business.card && business.card.brand && business.card.last4 && business.card.expMonth && business.card.expYear 
                        ? `${business.card.brand} **** **** **** ${business.card.last4} - ${business.card.expMonth}/${business.card.expYear}` 
                        : 'Card information incomplete'}
                    </Typography>
                  </Box>
                </CardContent>
                <CardActions>
                  <Box display="flex" flexDirection="column" gap={1} width="100%">
                    {/* Top row - contained variant */}
                    <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
                      <Button disabled={readOnly} color="primary" variant="contained" onClick={() => setShowBalancePopup(true)}>
                        Add balance
                      </Button>
                      <Button disabled={readOnly} color="primary" variant="contained" onClick={() => setShowPaymentForm(true)}>
                        Add new card
                      </Button>
                      <Button disabled={readOnly} color="primary" variant="contained" onClick={() => setShowCardSelection(true)}>
                        Change card
                      </Button>
                    </Box>
                    {/* Bottom row - current styling */}
                    <Box display="flex" alignItems="center" flexWrap="wrap" gap={1}>
                      <Button disabled={readOnly} color="primary" onClick={() => setShowPromoPopup(true)}>
                        Enter promo code
                      </Button>
                      <AutoReloadButton disabled={readOnly}
                        onClick={() => setShowReloadPopup(true)}
                      />
                      <Button disabled={readOnly}
                        color="error"
                        onClick={() => setConfirmDelete(true)}
                      >
                        Delete card
                      </Button>
                    </Box>
                  </Box>
                </CardActions>
              </Card>
            </Grid>
          )}
          {showPaymentForm && !readOnly && (
            <NewCardPaymentForm
              business={business}
              onClose={() => setShowPaymentForm(false)}
            />
          )}
        </Grid>
        {showCardSelection && !readOnly && (
          <AddCard
            businessId={business.businessId}
            cards={userCards}
            //cards={attachedCards}
            card={get(business, 'card.id')}
            onClose={() => setShowCardSelection(false)}
          />
        )}
        {showBalancePopup && !readOnly && <AddBalance businessId={business.businessId} onClose={() => setShowBalancePopup(false)} />}
        {showReloadPopup && !readOnly && <SetReload businessId={business.businessId} onClose={() => setShowReloadPopup(false)} />}
        {showPromoPopup && !readOnly && <AddPromo businessId={business.businessId} onClose={() => setShowPromoPopup(false)} />}

        {confirmDelete && !readOnly && (
        <ConfirmationDialog
          isOpen
          title="Delete card"
          body="Are you sure you want to delete your card?"
          successButtonLabel="Delete"
          onCancel={() => setConfirmDelete(false)}
          onConfirm={() => handleDeleteCard(userCards[0].id)}
        />
      )}
      </Box>
      </fieldset>
    </BusinessPage>
  );
};

export default Credits;
